import { useSelector } from '@xstate/react';

import { useEssentialMachines } from '../../EssentialMachines';

// ─────────────────────────────────────────────────────────────────────────────

export const useIsLoggingIn = () => {
  const { authMachineRef } = useEssentialMachines();

  const isLoggingIn = useSelector(authMachineRef, (state) => {
    const isFetchingSession =
      state.matches('fetching-session') || state.matches('retrying-session');
    const isFetchingCustomer =
      !state.matches({ session: 'loggedIn' }) && state.matches({ fetching: 'customer' });

    return isFetchingSession || isFetchingCustomer;
  });

  return Boolean(isLoggingIn);
};
